













































































































// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// components
import { Input, Radio, InputTime, CheckBox, Select2, DatePicker, Select } from '@/components/form'

// Vuelidate
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

// models
import { EmployeeModel } from '@/models/config'
import { AssistanceForm } from '@/models/assistance'

// utils
import { loading, alerts, getFullNameFormat } from '@/utils'

// services
import { EmployeeService } from '@/services/config'
import { AssistanceService } from '@/services/assistance'
import { PropOptionSelect } from '@/models'
import moment from 'moment'

@Component({
    name: 'FormCreateEditAssistance',
    components: {
        Input,
        Radio,
        InputTime,
        CheckBox,
        Select2,
        Select,
        DatePicker
    },
    mixins: [validationMixin]
})
export default class FormCreateEditAssistance extends Vue {
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ type: String, default: '' }) type!: string
    @Prop({ required: true }) assistance!: AssistanceForm
    @Prop({ type: Number, default: null }) idEdit!: number|null

    employees: EmployeeModel[] = []
    form: AssistanceForm = {
        checkin_time: '',
        checkout_time: '',
        employee_id: null,
        date: null,
        absence: false,
        reason_absence: null
    }

    // 1: Falta, 2: Intermitente, 3: Permiso u Otros, 4: Supención
    reasonAbsenceOp: PropOptionSelect[] = [
        {
            value: 1,
            text: 'Falta'
        },
        {
            value: 2,
            text: 'Intermitente'
        },
        {
            value: 3,
            text: 'Permiso u Otros'
        },
        {
            value: 4,
            text: 'Suspención'
        }
    ]

    created () {
        this.getEmployees()
        if (this.idEdit) {
const horaConSegundos = this.assistance.checkin_time
const horaConSegundos2 = this.assistance.checkout_time
const horaSinSegundos = moment(horaConSegundos, 'HH:mm:ss').format('HH:mm')
const horaSinSegundos2 = moment(horaConSegundos2, 'HH:mm:ss').format('HH:mm')
            this.form = {
                checkin_time: horaSinSegundos,
                checkout_time: horaSinSegundos2,
                employee_id: this.assistance.employee_id,
                date: this.assistance.date,
                absence: this.assistance.absence,
                reason_absence: this.assistance.reason_absence
            }
        } else {
this.form.date = moment(new Date()).format('YYYY-MM-DD')
        }
    }

    @Validations()
    validations () {
        if (this.form.absence) {
            return {
                form: {
                    employee_id: { required },
                    date: { required },
                    reason_absence: { required },
                    checkin_time: { required: false },
                    checkout_time: { required: false }
                }
            }
        } else {
            return {
                form: {
                    checkin_time: { required },
                    checkout_time: { required },
                    employee_id: { required },
                    date: { required }
                }
            }
        }
    }

    async getEmployees () {
        this.employees = await EmployeeService.getActivated()
    }

    async save () {
        this.$v.$touch()
        if (!this.$v.$anyError) {
            loading('show')
            try {
                if (this.actionForm === 'update' && this.idEdit !== null) {
                    await AssistanceService.update(this.idEdit, this.form)
                } else {
                    await AssistanceService.create(this.form)
                }
                alerts.success()
                this.$v.$reset()
                this.form = {
                    checkin_time: '',
                    checkout_time: '',
                    employee_id: null,
                    date: null,
                    absence: false,
                    reason_absence: null
                }
                this.$emit('save-success')
            } catch (e) {
                alerts.error('Se ha presentado errores en la operación')
            }
            loading('hide')
            this.$v.$reset()
        } else {
            alerts.error('Debe completar todos los campos requeridos')
        }
        loading('hide')
    }

    get employeesOp (): PropOptionSelect[] {
        const options: PropOptionSelect[] = []
        this.employees.forEach(e => {
            options.push({
                value: e.id || null,
                text: getFullNameFormat(e)
            })
        })
        return options
    }
}
